import React, { useState, useEffect } from 'react';
import BreakCrumbs from '../../components/BreakCrumbs';
import {
  Box,
  Paper,
  Grid,
  Typography,
  Button,
  Divider,
  TextField,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import TableLoading from '../../components/TableLoading';
import { alertError } from '../../Util/Util';
import TableEmpty from '../../components/TableEmpty';
import { LIST_PAGE_COUNT } from '../../data/common';
import { trim } from 'lodash';
import moment from 'moment';
import { DatePicker } from '@material-ui/pickers';
import memberAPI from '../../middleware/memberAPI';
import UserPayingMemberTable from '../../components/MemberManagement/UserPayingMemberTable';
import subscriptionAPI from '../../middleware/subscriptionAPI';
import UserSubscriptionServiceTable from '../../components/Subscriptions/UserSubscriptionServiceTable';

const UserSubscriptionServiceList = (props) => {
  const { match } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [userSubscriptionServices, setUserSubscriptionServices] = useState();
  const [total, setTotal] = useState();
  const [pageNum, setPageNum] = useState(1);
  const [keyword, setKeyword] = useState('');
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  useEffect(() => {
    getUserSubscriptionServices();
  }, [pageNum]);

  const getUserSubscriptionServices = () => {
    setIsLoading(true);

    const startAt =
      trim(startDate) !== '' ? moment(startDate).format('YYYY-MM-DD') : '';

    const endAt =
      trim(endDate) !== '' ? moment(endDate).format('YYYY-MM-DD') : '';

    subscriptionAPI
      .getAllUserSubscriptionServices(
        pageNum,
        LIST_PAGE_COUNT,
        keyword,
        startAt,
        endAt,
      )
      .then(
        (rs) => {
          if (rs.totalCount <= 0) {
            setUserSubscriptionServices(undefined);
            setTotal(0);
          } else {
            setUserSubscriptionServices(rs.subscriptionTransactionList);
            setTotal(rs.totalCount);
          }
        },
        (error) => {
          alertError(error);
        },
      )
      .then(() => {
        setIsLoading(false);
      });
  };

  const handleKeyword = (e) => {
    const value = trim(e.target.value);

    setKeyword(value);
  };

  const handleSearch = () => {
    setPageNum(1);

    if (pageNum === 1) {
      getUserSubscriptionServices();
    }
  };

  const handleChangeStartDate = (e) => {
    setStartDate(e);
  };

  const handleChangeEndDate = (e) => {
    setEndDate(e);
  };

  return (
    <div className="popular pagefadeIn">
      <BreakCrumbs path={match.url}></BreakCrumbs>

      <Box component={Paper} square elevation={2} p={1} mt={3} mb={3}>
        <Grid
          container
          direction="row"
          justify="space-around"
          alignItems="center">
          <Grid item xs>
            <Typography variant="h4" color="textPrimary" gutterBottom>
              訂閱記錄
            </Typography>
          </Grid>
        </Grid>

        <Divider light />

        <Box textAlign="right" mt={2} mb={2}>
          <DatePicker
            autoOk
            label="開始時間"
            clearable
            disableFuture
            inputVariant="outlined"
            value={startDate || null}
            onChange={handleChangeStartDate}
            format="yyyy-MM-dd"
            size="small"
            style={{
              margin: '6px 12px 6px 0',
            }}
          />

          <DatePicker
            autoOk
            label="結束時間"
            clearable
            disableFuture
            inputVariant="outlined"
            value={endDate || null}
            onChange={handleChangeEndDate}
            format="yyyy-MM-dd"
            size="small"
            style={{
              margin: '6px 12px 6px 0',
            }}
          />

          <TextField
            label="手機/姓名 搜尋"
            type="search"
            variant="outlined"
            size="small"
            disabled={isLoading}
            value={keyword}
            onChange={handleKeyword}
            style={{ margin: '6px 12px 6px 0' }}
            onKeyUp={(e) => {
              if (e.key === 'Enter') {
                handleSearch();
              }
            }}
          />

          <Button
            variant="contained"
            color="primary"
            startIcon={<SearchIcon />}
            disabled={isLoading}
            onClick={handleSearch}
            style={{
              margin: '6px 12px 6px 0',
            }}>
            搜尋
          </Button>
        </Box>

        {isLoading && <TableLoading />}

        {!isLoading && !userSubscriptionServices && (
          <TableEmpty message="查無訂閱記錄" />
        )}

        {!isLoading && userSubscriptionServices && (
          <UserSubscriptionServiceTable
            userSubscriptionServices={userSubscriptionServices}
            total={total}
            pageNum={pageNum}
            setPageNum={setPageNum}
          />
        )}
      </Box>
    </div>
  );
};

export default UserSubscriptionServiceList;
